import type { NpcFaction, NpcHullTier, NpcUnit } from "./types";

// Splits a (possibly Wave-staged) composition string into per-stage
// segments. Wave encounters join each "Wn: ..." segment with " | "
// (src/data/loadEncounters.ts); non-wave encounters are just a single
// segment, so this split works unconditionally without checking `structure`.
export function parseStageSegments(composition: string): string[] {
  return composition.split(" | ").map((segment) => segment.replace(/^W\d+:\s*/, "").trim());
}

export interface CompositionUnitCount {
  unit: NpcUnit;
  count: number;
}

// Parses a single stage segment (e.g. "2x Raider+3x Micro (15s repair
// gaps)") into its constituent unit types and counts, looking each role
// name up against the unit roster for the given faction/hull tier.
export function parseCompositionUnits(
  segment: string,
  faction: NpcFaction,
  hullTier: NpcHullTier,
  units: NpcUnit[]
): CompositionUnitCount[] {
  const withoutTrailingNote = segment.replace(/\s*\([^)]*\)\s*$/, "");
  return withoutTrailingNote.split(/\s*\+\s*/).map((part) => {
    const match = part.trim().match(/^(\d+)x\s+(.+)$/i);
    if (!match) {
      throw new Error(`Unrecognized composition segment: "${part}"`);
    }
    const count = Number(match[1]);
    const roleName = match[2].trim();
    const unit = units.find(
      (u) => u.faction === faction && u.hullTier === hullTier && u.name.endsWith(roleName)
    );
    if (!unit) {
      throw new Error(`No unit found for "${roleName}" (${faction} ${hullTier})`);
    }
    return { unit, count };
  });
}
